import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/ResearchDevelopmentConsultancyComponenets/ResearchPageSection/ResearchPageSection.tsx");
